<script setup lang="ts">
interface Props {
  designations: string[]
}

defineProps<Props>()
</script>

<template>
  <span class="w-full break-words text-left text-sm font-light">{{
    designations.join(' & ')
  }}</span>
</template>
